export const allPlaylistTopics = [
    {
        id: '565b1128c187444886cf21f3d96938c0',
        internalId: '3d',
        enName: '3D',
        name: '3D',
        archived: 'false',
        apps: ['ACRS', 'AERO', 'AEFT', 'FLPR', 'ILST', 'STOK', 'STGR'],
    },
    {
        id: 'aba9ec428038450092830ee2bffa19a6',
        internalId: 'accessibility',
        enName: 'Accessibility',
        name: 'Accessibility',
        archived: 'false',
        apps: ['ACRS', 'FLPR', 'ILST', 'PPRO'],
    },
    {
        id: 'df0bc2f3affa4bf68d37ed44a4fe83bb',
        internalId: 'account-management',
        enName: 'Account management',
        name: 'Account management',
        archived: 'false',
        apps: ['PHSP', 'STGR', 'SBSTD', 'SHPR', 'SBSTP', 'SBSTA'],
    },
    {
        id: 'd551c145038f4830baeff7010bf30bce',
        internalId: 'actions',
        enName: 'Actions',
        name: 'Actions',
        archived: 'false',
        apps: ['AERO', 'PHSP', 'PSWB', 'PPRO'],
    },
    {
        id: '5e247767973a48d3a163c4935cd69ad3',
        internalId: 'add-objects-to-images',
        enName: 'Add object to images',
        name: 'Add object to images',
        archived: 'false',
        apps: ['PHSP', 'PHSP', 'PSWB', 'FFLY'],
    },
    {
        id: 'd31daf87d6b7439e83e1999875c214d8',
        internalId: 'adding-photos',
        enName: 'Adding photos',
        name: 'Adding photos',
        archived: 'false',
        apps: ['PHSP', 'PHSP', 'PSWB'],
    },
    {
        id: '8ab1e36558ab4a628cbea11845c30f7a',
        internalId: 'adjustments',
        enName: 'Adjustments',
        name: 'Adjustments',
        archived: 'false',
        apps: ['LTRM', 'PHSP', 'PHSP', 'PSWB'],
    },
    {
        id: '3067432ec8974d98bb77660e8210df4b',
        internalId: 'alignment',
        enName: 'Alignment',
        name: 'Alignment',
        archived: 'false',
        apps: ['FRSC', 'ILST', 'ILST', 'IDSN', 'PHSP', 'PSWB'],
    },
    {
        id: '5ffb1a4ede364a69bdec7c8779a5722e',
        internalId: 'anchors',
        enName: 'Anchors',
        name: 'Anchors',
        archived: 'false',
        apps: ['AERO', 'SBSTP'],
    },
    {
        id: '4931735f710f4382a1919d8ac5015e71',
        internalId: 'animation',
        enName: 'Animation',
        name: 'Animation',
        archived: 'false',
        apps: ['CCEX', 'AERO', 'AEFT', 'FLPR', 'FRSC', 'IDSN', 'PHSP', 'PPRO'],
    },
    {
        id: 'f5d775769e854835a9614c217d917c8e',
        internalId: 'annotation',
        enName: 'Annotation',
        name: 'Annotation',
        archived: 'false',
        apps: ['ACRS'],
    },
    {
        id: '2d954fedafd34790b12524b6df7188cc',
        internalId: 'api',
        enName: 'APIs',
        name: 'APIs',
        archived: 'false',
        apps: ['STOK'],
    },
    {
        id: 'e3d85aa39c5b4d5daf82341e953d19b4',
        internalId: 'appearance',
        enName: 'Appearance',
        name: 'Appearance',
        archived: 'false',
        apps: ['ILST', 'ILST', 'PSWB'],
    },
    {
        id: 'b11f6958a2e44f0ebc5b421e81364a26',
        internalId: 'ar',
        enName: 'AR',
        name: 'AR',
        archived: 'false',
        apps: ['AERO'],
    },
    {
        id: 'b5025c4b34ae4b6d9866139f7af8f7fd',
        internalId: 'artboards',
        enName: 'Artboards',
        name: 'Artboards',
        archived: 'false',
        apps: ['ILST', 'ILST', 'PHSP', 'PSWB'],
    },
    {
        id: '0c34ce1e2690486eb0547fd35feaa7ea',
        internalId: 'asset-warp',
        enName: 'Asset Warp',
        name: 'Asset Warp',
        archived: 'false',
        apps: ['ILST'],
    },
    {
        id: '81b008a2d3b04e3294b4c8ccc0daaeb9',
        internalId: 'assets',
        enName: 'Assets',
        name: 'Assets',
        archived: 'false',
        apps: ['CCEX', 'AERO', 'FLPR', 'ILST', 'ILST', 'PHSP', 'STOK'],
    },
    {
        id: '112b19b127234036958b7492690303e5',
        internalId: 'attachments',
        enName: 'Attachments',
        name: 'Attachments',
        archived: 'false',
        apps: ['ACRS'],
    },
    {
        id: 'da0d60b4b806415f931d9ba3a1ee6d02',
        internalId: 'audio',
        enName: 'Audio',
        name: 'Audio',
        archived: 'false',
        apps: ['AERO', 'AEFT', 'FLPR', 'PHSP', 'PPRO', 'RUSH', 'STOK'],
    },
    {
        id: 'adce2a8ba0724a64a6d69e1288654852',
        internalId: 'audio-editing',
        enName: 'Audio editing',
        name: 'Audio editing',
        archived: 'false',
        apps: ['PPRO'],
    },
    {
        id: '5515b21c8c2a4d4f8f610e4d73bf6608',
        internalId: 'audio-effects',
        enName: 'Audio effects',
        name: 'Audio effects',
        archived: 'false',
        apps: ['PPRO'],
    },
    {
        id: '072fe911da884d538c60470e4da691a3',
        internalId: 'automation',
        enName: 'Automation',
        name: 'Automation',
        archived: 'false',
        apps: ['ACRS', 'AEFT', 'FLPR', 'ILST', 'IDSN', 'LPES_MBL', 'PHSP', 'RUSH'],
    },
    {
        id: '0c1f977660ae483aab0f4fdd8e3f08fd',
        internalId: 'background',
        enName: 'Background',
        name: 'Background',
        archived: 'false',
        apps: ['CCEX', 'ILST', 'ILST', 'PHSP', 'PHSP', 'PSWB', 'STGR'],
    },
    {
        id: 'a449317bf3fb4594a40234be2bf64557',
        internalId: 'baking',
        enName: 'Baking',
        name: 'Baking',
        archived: 'false',
        apps: ['SBSTP'],
    },
    {
        id: '2b872d52867045a5ab8e3ad2565da900',
        internalId: 'behaviors',
        enName: 'Behaviors',
        name: 'Behaviors',
        archived: 'false',
        apps: ['ANML'],
    },
    {
        id: '7118aba735304f8ea951b78a25d5c806',
        internalId: 'blending',
        enName: 'Blending',
        name: 'Blending',
        archived: 'false',
        apps: ['SBSTD'],
    },
    {
        id: '972e8ca1dd5e4e91a44a19e4244ec583',
        internalId: 'booleans',
        enName: 'Booleans',
        name: 'Booleans',
        archived: 'false',
        apps: ['SHPR'],
    },
    {
        id: 'ed18cc2193fd4bfdbaba4031dec3f800',
        internalId: 'branding',
        enName: 'Branding',
        name: 'Branding',
        archived: 'false',
        apps: ['CCEX', 'ILST', 'ILST', 'PHSP', 'PHSP', 'PSWB', 'STOK'],
    },
    {
        id: '3e652fd69a634a948308dc865d01423d',
        internalId: 'brightness',
        enName: 'Brightness',
        name: 'Brightness',
        archived: 'false',
        apps: ['ILST', 'PHSP', 'PHSP', 'PSWB'],
    },
    {
        id: '15fc3f05b7ea40cfa4d5ba2e18944c5d',
        internalId: 'broadcast',
        enName: 'Broadcast',
        name: 'Broadcast',
        archived: 'false',
        apps: ['PPRO', 'RUSH'],
    },
    {
        id: 'bd68e232473849d6bc60aac582ae1a37',
        internalId: 'brushes',
        enName: 'Brushes',
        name: 'Brushes',
        archived: 'false',
        apps: ['FLPR', 'FRSC', 'ILST', 'ILST', 'PHSP', 'PHSP', 'PSWB', 'SHPR', 'SBSTP'],
    },
    {
        id: '4391ff51c2154029abfbce1a81032e16',
        internalId: 'camera',
        enName: 'Camera',
        name: 'Camera',
        archived: 'false',
        apps: ['AERO', 'AEFT', 'FLPR', 'ANML', 'LPES_MBL', 'PPRO', 'SBSTD'],
    },
    {
        id: '42fd7ea0fd45433e81b0c64e8adfcc75',
        internalId: 'card-design',
        enName: 'Card design',
        name: 'Card design',
        archived: 'false',
        apps: ['ILST', 'ILST', 'IDSN'],
    },
    {
        id: '4e981d5972c448af893eb250bc6e370d',
        internalId: 'catalogs',
        enName: 'Catalogs',
        name: 'Catalogs',
        archived: 'false',
        apps: ['LTRM'],
    },
    {
        id: '075616eeadcd40b1a0524e4641babe6a',
        internalId: 'channels',
        enName: 'Channels',
        name: 'Channels',
        archived: 'false',
        apps: ['AEFT', 'SBSTP'],
    },
    {
        id: '01472a89a699490295b7944d35db65c0',
        internalId: 'character-animation',
        enName: 'Character animation',
        name: 'Character animation',
        archived: 'false',
        apps: ['FLPR'],
    },
    {
        id: '775481e3d22e4394bff410238002f4b5',
        internalId: 'character-design',
        enName: 'Character design',
        name: 'Character design',
        archived: 'false',
        apps: ['ILST', 'ILST', 'ANML'],
    },
    {
        id: '6dd9695b87e14b90aef653bcb56977de',
        internalId: 'cinema4d',
        enName: 'Cinema4D',
        name: 'Cinema4D',
        archived: 'false',
        apps: ['AEFT'],
    },
    {
        id: '4b27994c1a2e4f7792dd4183402d799d',
        internalId: 'clarity',
        enName: 'Clarity',
        name: 'Clarity',
        archived: 'false',
        apps: ['LPES_MBL'],
    },
    {
        id: '90e1d8dd58a241f4aa317f9581c02ff1',
        internalId: 'clips',
        enName: 'Clips',
        name: 'Clips',
        archived: 'false',
        apps: ['PPRO'],
    },
    {
        id: 'd6199dd6f65849419cf32984589cebb4',
        internalId: 'collaboration',
        enName: 'Collaboration',
        name: 'Collaboration',
        archived: 'false',
        apps: ['AERO', 'AEFT', 'ILST', 'ILST', 'LTRM', 'PHSP', 'PHSP', 'PSWB', 'PPRO', 'STOK'],
    },
    {
        id: '0b866e9c90384a2a8a4feefa187d13f4',
        internalId: 'color',
        enName: 'Color',
        name: 'Color',
        archived: 'false',
        apps: [
            'ACRS',
            'AEFT',
            'FLPR',
            'FRSC',
            'ILST',
            'ILST',
            'IDSN',
            'LTRM',
            'LPES_MBL',
            'PHSP',
            'PEXP',
            'PHSP',
            'PSWB',
            'PPRO',
            'SBSTA',
        ],
    },
    {
        id: 'c6445504751c470c814839a1401c0d18',
        internalId: 'color-grading',
        enName: 'Color grading',
        name: 'Color grading',
        archived: 'false',
        apps: ['PPRO'],
    },
    {
        id: '88d6520b6502425fa625f35dc1f4d4b2',
        internalId: 'colorize',
        enName: 'Colorize',
        name: 'Colorize',
        archived: 'false',
        apps: ['PHSP', 'PHSP', 'PSWB'],
    },
    {
        id: 'eaa4b795e843418f9205392c2e488e7f',
        internalId: 'component',
        enName: 'Component',
        name: 'Component',
        archived: 'false',
        apps: ['FLPR'],
    },
    {
        id: 'd1dc61ee99ef467b92ef8692ee0dcb84',
        internalId: 'compositing',
        enName: 'Compositing',
        name: 'Compositing',
        archived: 'false',
        apps: ['LPES', 'PHSP', 'PEXP', 'PHSP', 'PSWB', 'PPRO'],
    },
    {
        id: '17bac22a480c4dada3b2fe2d96cca70a',
        internalId: 'composition',
        enName: 'Composition',
        name: 'Composition',
        archived: 'false',
        apps: ['AEFT', 'PHSP', 'PHSP', 'PSWB'],
    },
    {
        id: '189be2b34ae044a9a7491c12d844768f',
        internalId: 'content-creation',
        enName: 'Content creation',
        name: 'Content creation',
        archived: 'false',
        apps: ['ILST', 'ILST', 'IDSN', 'PHSP', 'PHSP', 'PSWB', 'STOK'],
    },
    {
        id: 'ad98647b96ab42d8b14aa4ea01de6e25',
        internalId: 'content-marketing-and-design',
        enName: 'Content marketing and design',
        name: 'Content marketing and design',
        archived: 'false',
        apps: ['FLPR', 'STOK', 'STGR'],
    },
    {
        id: '3dd2d07225624c98a5646efa2c16fab4',
        internalId: 'content-aware-fill',
        enName: 'Content-Aware Fill',
        name: 'Content-Aware Fill',
        archived: 'false',
        apps: ['AEFT', 'PHSP', 'PHSP', 'PSWB'],
    },
    {
        id: '481c9f618922491ebd3111de39b86355',
        internalId: 'convert',
        enName: 'Convert',
        name: 'Convert',
        archived: 'false',
        apps: ['AEFT', 'ILST'],
    },
    {
        id: 'db5f26a051b54a95b1599b13b4ffc2ce',
        internalId: 'creating-color-palettes',
        enName: 'Creating color palettes',
        name: 'Creating color palettes',
        archived: 'false',
        apps: ['ILST', 'ILST'],
    },
    {
        id: '24ff0e8cc5764c6989eab477e3c7c48a',
        internalId: 'creative-cloud',
        enName: 'Creative Cloud',
        name: 'Creative Cloud',
        archived: 'false',
        apps: ['ILST', 'ILST', 'LPES_MBL', 'PHSP', 'PHSP', 'PSWB'],
    },
    {
        id: '16ca670268094cb5b890172f1522d75c',
        internalId: 'creative-cloud-libraries',
        enName: 'Creative Cloud Libraries',
        name: 'Creative Cloud Libraries',
        archived: 'false',
        apps: ['CCEX', 'AEFT', 'FLPR', 'FRSC', 'ILST', 'ILST', 'IDSN', 'LTRM', 'PHSP', 'PHSP', 'PPRO', 'STOK'],
    },
    {
        id: '96a0db0625324adfaaee16dde4533dac',
        internalId: 'creative-effects',
        enName: 'Creative effects',
        name: 'Creative effects',
        archived: 'false',
        apps: ['FRSC', 'ILST', 'ILST', 'PHSP', 'PHSP', 'PSWB', 'PPRO', 'STOK'],
    },
    {
        id: 'd410ce1844bc46829357314d1b15463f',
        internalId: 'crop',
        enName: 'Crop',
        name: 'Crop',
        archived: 'false',
        apps: ['ILST', 'ILST', 'LPES_MBL', 'PHSP', 'PEXP', 'PHSP', 'PSWB', 'SBSTA'],
    },
    {
        id: '169c658d8043402cb8aa1aadfe2eefdd',
        internalId: 'cross-product-workflows',
        enName: 'Cross-product workflows',
        name: 'Cross-product workflows',
        archived: 'false',
        apps: [
            'AEFT',
            'FLPR',
            'FRSC',
            'ILST',
            'ILST',
            'IDSN',
            'LPES',
            'LTRM',
            'LPES_MBL',
            'PHSP',
            'PHSP',
            'PSWB',
            'PPRO',
            'STOK',
            'SBSTP',
        ],
    },
    {
        id: '9f0c041d2b9e42838dde14d54f55befc',
        internalId: 'css',
        enName: 'CSS',
        name: 'CSS',
        archived: 'false',
        apps: ['PHSP'],
    },
    {
        id: '19a58213720241429f11e6403451dcd3',
        internalId: 'curves',
        enName: 'Curves',
        name: 'Curves',
        archived: 'false',
        apps: ['ILST', 'ILST', 'LPES_MBL', 'PHSP', 'PHSP', 'PPRO'],
    },
    {
        id: '29efa88696804334b27dbc22c523ccbe',
        internalId: 'custom-lettering',
        enName: 'Custom lettering',
        name: 'Custom lettering',
        archived: 'false',
        apps: ['ILST', 'ILST'],
    },
    {
        id: '2a12deb2ce2a4c559ed834c489ce1719',
        internalId: 'data-and-analytics',
        enName: 'Data and analytics',
        name: 'Data and analytics',
        archived: 'false',
        apps: ['ILST'],
    },
    {
        id: '96a25929907543e2be422021d66c03ad',
        internalId: 'data-visualizations',
        enName: 'Data visualizations',
        name: 'Data visualizations',
        archived: 'false',
        apps: ['STOK'],
    },
    {
        id: '1119d74bd67d43bbb16a302489d486e4',
        internalId: 'decals',
        enName: 'Decals',
        name: 'Decals',
        archived: 'false',
        apps: ['STGR', 'SBSTP'],
    },
    {
        id: 'ae905badd69f40859f556f108a351fa4',
        internalId: 'dehaze',
        enName: 'Dehaze',
        name: 'Dehaze',
        archived: 'false',
        apps: ['LPES_MBL'],
    },
    {
        id: '239b9b4aa3a34d61b8db7b73f3d1a991',
        internalId: 'developer-handoff',
        enName: 'Developer handoff',
        name: 'Developer handoff',
        archived: 'false',
        apps: [],
    },
    {
        id: '75ec60c886c447909d30d32842ac749f',
        internalId: 'digital-design',
        enName: 'Digital design',
        name: 'Digital design',
        archived: 'false',
        apps: ['ILST', 'ILST'],
    },
    {
        id: '64327a14298b4ba08af4fe93dbb83ce1',
        internalId: 'distortions',
        enName: 'Distortions',
        name: 'Distortions',
        archived: 'false',
        apps: ['SBSTA'],
    },
    {
        id: 'e533531eb1e043f19f6a48ad75a46cba',
        internalId: 'document-cloud',
        enName: 'Document Cloud',
        name: 'Document Cloud',
        archived: 'false',
        apps: ['AERO', 'FRSC', 'ILST', 'ILST'],
    },
    {
        id: '895f00a58e794b3cb67bb65a49f66653',
        internalId: 'documents',
        enName: 'Documents',
        name: 'Documents',
        archived: 'false',
        apps: ['IDSN'],
    },
    {
        id: '3237e1d4694e405a912a33894fdd653c',
        internalId: 'double-exposure',
        enName: 'Double exposure',
        name: 'Double exposure',
        archived: 'false',
        apps: ['PHSP'],
    },
    {
        id: '265bedc388ea4a7db33ddf87b7acf689',
        internalId: 'download-and-install',
        enName: 'Download and Install',
        name: 'Download and Install',
        archived: 'false',
        apps: ['AEFT'],
    },
    {
        id: '43d3f4276fd742cea43e9092e2a6b05b',
        internalId: 'drawing',
        enName: 'Drawing',
        name: 'Drawing',
        archived: 'false',
        apps: ['AEFT', 'FLPR', 'FRSC', 'ILST', 'ILST', 'PHSP', 'PHSP', 'PSWB'],
    },
    {
        id: '50269f8511db48e9a564b7abbf1df37c',
        internalId: 'ducking',
        enName: 'Ducking',
        name: 'Ducking',
        archived: 'false',
        apps: ['PPRO'],
    },
    {
        id: 'c19731b8cfe34b4a869ef96cc7ac3a52',
        internalId: 'edit',
        enName: 'Edit',
        name: 'Edit',
        archived: 'false',
        apps: ['ACRS', 'FRSC', 'ILST', 'ILST', 'LTRM', 'PHSP', 'PSWB', 'PPRO'],
    },
    {
        id: 'fadb0bb977c241c5b1f486e40aef4c15',
        internalId: 'effects',
        enName: 'Effects',
        name: 'Effects',
        archived: 'false',
        apps: ['AEFT', 'FRSC', 'ILST', 'LPES_MBL', 'PHSP', 'PEXP', 'PSWB', 'PPRO', 'RUSH', 'SBSTD', 'SBSTP'],
    },
    {
        id: '5787885378d549d8a9049ba42a7702f3',
        internalId: 'enhancing-color',
        enName: 'Enhancing color',
        name: 'Enhancing color',
        archived: 'false',
        apps: ['PHSP', 'PHSP', 'PSWB'],
    },
    {
        id: 'f34e0930a32a4de9bc658167cf117ef5',
        internalId: 'environments',
        enName: 'Environments',
        name: 'Environments',
        archived: 'false',
        apps: ['SBSTD', 'SBSTP'],
    },
    {
        id: 'c41ee59bcc7c4257beff477f24b67c45',
        internalId: 'epub',
        enName: 'EPUB',
        name: 'EPUB',
        archived: 'false',
        apps: ['IDSN'],
    },
    {
        id: 'ebbc8a57521947ecb42ca8fb8e6bbde8',
        internalId: 'essential-properties',
        enName: 'Essential properties',
        name: 'Essential properties',
        archived: 'false',
        apps: ['AEFT'],
    },
    {
        id: '1b96859c7bc4404295fceb4e67706dbd',
        internalId: 'export',
        enName: 'Export',
        name: 'Export',
        archived: 'false',
        apps: [
            'ACRS',
            'AERO',
            'AEFT',
            'FLPR',
            'ANML',
            'FRSC',
            'ILST',
            'ILST',
            'IDSN',
            'LPES',
            'LTRM',
            'LPES_MBL',
            'PHSP',
            'PHSP',
            'PSWB',
            'PPRO',
            'RUSH',
            'SBSTD',
            'SHPR',
            'SBSTP',
            'SBSTA',
        ],
    },
    {
        id: 'e25947c56be14ba5ad941bedcf3b9013',
        internalId: 'expressions',
        enName: 'Expressions',
        name: 'Expressions',
        archived: 'false',
        apps: ['AEFT'],
    },
    {
        id: '2222e371e6344ac2972e69edf3d0bef1',
        internalId: 'files',
        enName: 'Files',
        name: 'Files',
        archived: 'false',
        apps: ['FLPR', 'ILST', 'ILST', 'IDSN', 'PHSP', 'PHSP', 'PSWB'],
    },
    {
        id: '724044000ce24cdbbd0b3293e90f04c6',
        internalId: 'fill-and-sign',
        enName: 'Fill and Sign',
        name: 'Fill and Sign',
        archived: 'false',
        apps: ['ACRS'],
    },
    {
        id: '3c7371abfe76485ea14f9100fa710e67',
        internalId: 'filters',
        enName: 'Filters',
        name: 'Filters',
        archived: 'false',
        apps: ['FLPR', 'PHSP', 'PEXP', 'PSWB'],
    },
    {
        id: '1f0a20e29bea495f9d25b90baa2550b2',
        internalId: 'flyer-design',
        enName: 'Flyer design',
        name: 'Flyer design',
        archived: 'false',
        apps: ['ILST', 'ILST', 'IDSN'],
    },
    {
        id: '014e1e2ccc4641c2b638254002d34a00',
        internalId: 'fonts',
        enName: 'Fonts',
        name: 'Fonts',
        archived: 'false',
        apps: ['FLPR', 'FRSC', 'ILST', 'ILST', 'PHSP', 'PHSP', 'PSWB', 'RUSH'],
    },
    {
        id: '7dfdfc715739442089339da1845f9342',
        internalId: 'food-photography',
        enName: 'Food Photography',
        name: 'Food Photography',
        archived: 'false',
        apps: ['PSWB'],
    },
    {
        id: '326eeb982c9d459eaf51197e8e1afee5',
        internalId: 'footage',
        enName: 'Footage',
        name: 'Footage',
        archived: 'false',
        apps: ['AEFT', 'PPRO', 'STOK'],
    },
    {
        id: '63091c7ce9744c75a52c6e22f159fb4d',
        internalId: 'forms',
        enName: 'Forms',
        name: 'Forms',
        archived: 'false',
        apps: ['ACRS'],
    },
    {
        id: 'b0b4d7634ddd4306983d9f104625ef16',
        internalId: 'frames',
        enName: 'Frames',
        name: 'Frames',
        archived: 'false',
        apps: ['FLPR', 'PPRO'],
    },
    {
        id: 'bd5e1b236ba14e5980ba9df484c6da51',
        internalId: 'gallery',
        enName: 'Gallery',
        name: 'Gallery',
        archived: 'false',
        apps: ['LTRM'],
    },
    {
        id: 'b68831a79e42449d943ff2a0b0965b35',
        internalId: 'generative-ai',
        enName: 'Generative AI',
        name: 'Generative AI',
        archived: 'false',
        apps: ['FFLY', 'PHSP', 'CCEX', 'ILST', 'ACRS'],
    },
    {
        id: '3db4467bc3a9426b9e6926f139d18088',
        internalId: 'geospatial-data',
        enName: 'Geospatial data',
        name: 'Geospatial data',
        archived: 'false',
        apps: ['ACRS'],
    },
    {
        id: 'd02c57c7e5bf44719d9cbafcd45bde37',
        internalId: 'get-started',
        enName: 'Get started',
        name: 'Get started',
        archived: 'false',
        apps: [
            'ACRS',
            'CCEX',
            'AERO',
            'AEFT',
            'FLPR',
            'ANML',
            'FRSC',
            'ILST',
            'ILST',
            'IDSN',
            'LPES',
            'LTRM',
            'LPES_MBL',
            'PHSP',
            'PEXP',
            'PHSP',
            'PSWB',
            'PPRO',
            'RUSH',
            'STOK',
            'STGR',
            'SBSTD',
            'SHPR',
            'SBSTP',
            'SBSTA',
        ],
    },
    {
        id: '577d085eded54e1bb8bb47ab4b9f7ee3',
        internalId: 'gradient-mesh',
        enName: 'Gradient mesh',
        name: 'Gradient mesh',
        archived: 'false',
        apps: ['ILST', 'ILST'],
    },
    {
        id: 'ac2ee423096a4eafa3a9825237c0b98d',
        internalId: 'gradients',
        enName: 'Gradients',
        name: 'Gradients',
        archived: 'false',
        apps: ['ILST', 'ILST', 'PHSP', 'PHSP', 'PSWB', 'PPRO', 'STOK'],
    },
    {
        id: '1811d51f917c4ec6aacb109c2cf4ff3c',
        internalId: 'graphic-styles',
        enName: 'Graphic styles',
        name: 'Graphic styles',
        archived: 'false',
        apps: ['ILST'],
    },
    {
        id: '6a39c69be39b405fbbc67bb8977b278e',
        internalId: 'graphics',
        enName: 'Graphics',
        name: 'Graphics',
        archived: 'false',
        apps: ['FLPR', 'ILST', 'ILST', 'IDSN', 'PHSP', 'PPRO', 'STOK', 'STGR'],
    },
    {
        id: '967dd807ac274f16859595124a1f70d0',
        internalId: 'graphs',
        enName: 'Graphs',
        name: 'Graphs',
        archived: 'false',
        apps: ['ILST', 'SBSTD'],
    },
    {
        id: 'ec740072015e417a84cc31f2f079c325',
        internalId: 'grid',
        enName: 'Grids',
        name: 'Grids',
        archived: 'false',
        apps: ['FRSC', 'ILST', 'ILST', 'IDSN', 'PHSP', 'PSWB'],
    },
    {
        id: 'ddadb6cf296148c78a7c446f57022d0e',
        internalId: 'guides',
        enName: 'Guides',
        name: 'Guides',
        archived: 'false',
        apps: ['ILST', 'ILST', 'IDSN', 'PHSP', 'PSWB'],
    },
    {
        id: '94d88afbfc354ab6a319ef058104abf9',
        internalId: 'hdr',
        enName: 'HDR',
        name: 'HDR',
        archived: 'false',
        apps: ['LTRM', 'PHSP'],
    },
    {
        id: '28b03c83f64c46cf9ef9f68ed66f2525',
        internalId: 'hdri',
        enName: 'HDRI',
        name: 'HDRI',
        archived: 'false',
        apps: ['SBSTA'],
    },
    {
        id: '9c69856f22a24ef4a9c730b8ab7f55ce',
        internalId: 'height',
        enName: 'Height',
        name: 'Height',
        archived: 'false',
        apps: ['SBSTA'],
    },
    {
        id: 'e8a899ead8624415a163c487e783f168',
        internalId: 'html',
        enName: 'HTML',
        name: 'HTML',
        archived: 'false',
        apps: ['PHSP'],
    },
    {
        id: '4d3b45220f0b4bb994dbf09c076911aa',
        internalId: 'icon-design',
        enName: 'Icon design',
        name: 'Icon design',
        archived: 'false',
        apps: ['ILST', 'ILST'],
    },
    {
        id: 'd1d6f2ab065f40dc989c127d22e0ec42',
        internalId: 'illustration',
        enName: 'Illustration',
        name: 'Illustration',
        archived: 'false',
        apps: ['FRSC', 'ILST', 'ILST', 'PHSP', 'PHSP', 'PSWB', 'STOK'],
    },
    {
        id: 'cb38a97545cd42a69740e1d4d0538b32',
        internalId: 'image-quality',
        enName: 'Image quality',
        name: 'Image quality',
        archived: 'false',
        apps: ['PHSP', 'PSWB'],
    },
    {
        id: '76476e736ebb4e508df2747c4f7dc2b1',
        internalId: 'images',
        enName: 'Images',
        name: 'Images',
        archived: 'false',
        apps: ['AEFT', 'FLPR', 'ILST', 'ILST', 'PHSP', 'PHSP', 'PSWB', 'STOK', 'SBSTA'],
    },
    {
        id: '73ead4e72d824c67a634eef61675761b',
        internalId: 'import',
        enName: 'Import',
        name: 'Import',
        archived: 'false',
        apps: [
            'AERO',
            'AEFT',
            'FLPR',
            'ANML',
            'FRSC',
            'ILST',
            'ILST',
            'LPES',
            'LTRM',
            'LPES_MBL',
            'PHSP',
            'PPRO',
            'RUSH',
            'SHPR',
            'SBSTP',
            'SBSTA',
        ],
    },
    {
        id: '3a1625158dab47439e0f53e1a1b0f117',
        internalId: 'infographic',
        enName: 'Infographics',
        name: 'Infographics',
        archived: 'false',
        apps: ['ILST', 'ILST', 'STOK'],
    },
    {
        id: 'bd5976e9008848cf85b9c3157607d89b',
        internalId: 'instances',
        enName: 'Instances',
        name: 'Instances',
        archived: 'false',
        apps: ['SHPR'],
    },
    {
        id: '8d08ca2afada4859899b93bf664af1b7',
        internalId: 'interactivity',
        enName: 'Interactivity',
        name: 'Interactivity',
        archived: 'false',
        apps: ['AERO', 'FLPR', 'IDSN', 'LTRM'],
    },
    {
        id: '2a1da8cdb6714e5fa5d185e34b05c2ca',
        internalId: 'interface',
        enName: 'Interface',
        name: 'Interface',
        archived: 'false',
        apps: ['PPRO'],
    },
    {
        id: '21976bf030f04f9d8bcb733a2f695ad3',
        internalId: 'interior-design',
        enName: 'Interior design',
        name: 'Interior design',
        archived: 'false',
        apps: ['STGR'],
    },
    {
        id: '11fc1ab75eb3440987c0580b7bf12f7f',
        internalId: 'keyframes',
        enName: 'Keyframes',
        name: 'Keyframes',
        archived: 'false',
        apps: ['AEFT', 'FLPR', 'ANML', 'PPRO'],
    },
    {
        id: 'a856651674214f3ea3c2ee0609dcab49',
        internalId: 'keying',
        enName: 'Keying',
        name: 'Keying',
        archived: 'false',
        apps: ['AEFT'],
    },
    {
        id: 'd4b905d71bfc4521a9a448894edac935',
        internalId: 'known-issues',
        enName: 'Known issues',
        name: 'Known issues',
        archived: 'false',
        apps: ['PHSP', 'PHSP', 'PSWB', 'PPRO'],
    },
    {
        id: '34c3562791794c358ce59daf882e55bd',
        internalId: 'landscape-photography',
        enName: 'Landscape photography',
        name: 'Landscape photography',
        archived: 'false',
        apps: ['PSWB'],
    },
    {
        id: '0605b453f31c407fb6cb3132755c41ac',
        internalId: 'layers',
        enName: 'Layers',
        name: 'Layers',
        archived: 'false',
        apps: ['AEFT', 'ANML', 'FRSC', 'ILST', 'ILST', 'PHSP', 'PHSP', 'PSWB', 'PPRO', 'SHPR', 'SBSTP'],
    },
    {
        id: 'f3975b5fc0f246f1ace91516607d250e',
        internalId: 'layout',
        enName: 'Layout',
        name: 'Layout',
        archived: 'false',
        apps: ['ILST', 'ILST', 'IDSN', 'PHSP', 'PSWB', 'SHPR', 'STGR'],
    },
    {
        id: 'fe17b6fb416c45fe9826b0c36d120293',
        internalId: 'libraries',
        enName: 'Libraries',
        name: 'Libraries',
        archived: 'false',
        apps: ['FLPR', 'ANML', 'ILST', 'ILST', 'LTRM', 'LPES_MBL', 'PHSP', 'PHSP'],
    },
    {
        id: '228447fea4ea4ee48cd94d6350605886',
        internalId: 'lighting',
        enName: 'Lighting',
        name: 'Lighting',
        archived: 'false',
        apps: ['LPES_MBL', 'PHSP', 'PEXP', 'PHSP', 'PSWB', 'STGR', 'SBSTP', 'SBSTA'],
    },
    {
        id: 'f39128b3acde4a17a0716f5d607ed197',
        internalId: 'links',
        enName: 'Links',
        name: 'Links',
        archived: 'false',
        apps: ['ACRS', 'ILST'],
    },
    {
        id: 'c809ff99f9e846c89b364f5135acb9a8',
        internalId: 'lip-syncing',
        enName: 'Lip Syncing',
        name: 'Lip Syncing',
        archived: 'false',
        apps: ['FLPR', 'ANML'],
    },
    {
        id: 'ac431de8b3b045e88c4fa9b842b50afb',
        internalId: 'logo-design',
        enName: 'Logo design',
        name: 'Logo design',
        archived: 'false',
        apps: ['CCEX', 'FRSC', 'ILST', 'ILST'],
    },
    {
        id: '7140669e41e3409e94fdc3d8bef7a9e0',
        internalId: 'markers',
        enName: 'Markers',
        name: 'Markers',
        archived: 'false',
        apps: ['AEFT', 'PPRO'],
    },
    {
        id: 'c49f6efbfd6c4cea91496bc9aca45e05',
        internalId: 'masking',
        enName: 'Masking',
        name: 'Masking',
        archived: 'false',
        apps: ['AEFT', 'FLPR', 'FRSC', 'ILST', 'ILST', 'LPES', 'LTRM', 'LPES_MBL', 'PHSP', 'SBSTD', 'SBSTP'],
    },
    {
        id: '326adcf51bcb4e6db7188510985db8d1',
        internalId: 'materials',
        enName: 'Materials',
        name: 'Materials',
        archived: 'false',
        apps: ['STGR', 'SBSTD', 'SHPR', 'SBSTP', 'SBSTA'],
    },
    {
        id: 'aed098d5b7bc4e36afa504a964df6d52',
        internalId: 'matte',
        enName: 'Matte',
        name: 'Matte',
        archived: 'false',
        apps: ['AEFT'],
    },
    {
        id: '28f93a38c7604fcfbedc1b1307c3f829',
        internalId: 'media',
        enName: 'Media',
        name: 'Media',
        archived: 'false',
        apps: ['ACRS', 'PPRO'],
    },
    {
        id: 'a75837bd8c9a441d905ee0971ed98c83',
        internalId: 'metal',
        enName: 'Metal',
        name: 'Metal',
        archived: 'false',
        apps: ['SBSTD'],
    },
    {
        id: '49d056e2a6e7402a9ce79cfa3be39101',
        internalId: 'mobile-phone',
        enName: 'Mobile phone',
        name: 'Mobile phone',
        archived: 'false',
        apps: ['RUSH'],
    },
    {
        id: 'e1b0c7112e9245819689858ba62b6829',
        internalId: 'modeling',
        enName: 'Modeling',
        name: 'Modeling',
        archived: 'false',
        apps: ['STGR', 'SHPR'],
    },
    {
        id: '29ce015eba5d4f8d99f0d3333042c07d',
        internalId: 'motion-graphics',
        enName: 'Motion graphics',
        name: 'Motion graphics',
        archived: 'false',
        apps: ['CCEX', 'PPRO'],
    },
    {
        id: 'ccdf43a419cd492990445cc60bceef99',
        internalId: 'motion-tracking',
        enName: 'Motion tracking',
        name: 'Motion tracking',
        archived: 'false',
        apps: ['AEFT'],
    },
    {
        id: '13836ac964d641808cd6c1065639eeff',
        internalId: 'movie',
        enName: 'Movie',
        name: 'Movie',
        archived: 'false',
        apps: ['PPRO'],
    },
    {
        id: '6466457f68044f2cb434d46e86435a78',
        internalId: 'multitrack',
        enName: 'Multitrack',
        name: 'Multitrack',
        archived: 'false',
        apps: ['PPRO'],
    },
    {
        id: '6c3775b5f55348729ea67a5144b58819',
        internalId: 'navigation',
        enName: 'Navigation',
        name: 'Navigation',
        archived: 'false',
        apps: [],
    },
    {
        id: 'b3c7502265b04b06ae471bbd25b3983b',
        internalId: 'nodes',
        enName: 'Nodes',
        name: 'Nodes',
        archived: 'false',
        apps: ['SBSTD'],
    },
    {
        id: '4c288215536143ad94abcc1280ed32cd',
        internalId: 'noise',
        enName: 'Noise',
        name: 'Noise',
        archived: 'false',
        apps: ['LPES_MBL'],
    },
    {
        id: 'fed3eca5b6b14cfe9e10402cde22f984',
        internalId: 'normal-maps',
        enName: 'Normal maps',
        name: 'Normal maps',
        archived: 'false',
        apps: ['SBSTD'],
    },
    {
        id: '1345a3e00e4e4398ae6cecfbae4768c8',
        internalId: 'objects',
        enName: 'Objects',
        name: 'Objects',
        archived: 'false',
        apps: ['ILST', 'ILST', 'SHPR'],
    },
    {
        id: '67562e4d086e4a70980419da71ecccdd',
        internalId: 'ocr',
        enName: 'OCR',
        name: 'OCR',
        archived: 'false',
        apps: ['ACRS'],
    },
    {
        id: '836f1de8e0b349e98745e95af6114476',
        internalId: 'open',
        enName: 'Open',
        name: 'Open',
        archived: 'false',
        apps: ['ACRS', 'ILST', 'ILST', 'PHSP', 'PHSP', 'PSWB'],
    },
    {
        id: '3ca58f09dca34a569a52ac7de692b32e',
        internalId: 'organization',
        enName: 'Organization',
        name: 'Organization',
        archived: 'false',
        apps: ['ACRS', 'ILST', 'ILST', 'LPES', 'LTRM', 'LPES_MBL', 'PPRO'],
    },
    {
        id: 'd2a07360857e4261b0be4fe27d07731d',
        internalId: 'orientation',
        enName: 'Orientation',
        name: 'Orientation',
        archived: 'false',
        apps: [
            'ACRS',
            'CCEX',
            'AERO',
            'AEFT',
            'FLPR',
            'ANML',
            'FRSC',
            'ILST',
            'ILST',
            'IDSN',
            'LPES',
            'LTRM',
            'LPES_MBL',
            'PHSP',
            'PEXP',
            'PHSP',
            'PSWB',
            'PPRO',
            'RUSH',
            'STOK',
            'SHPR',
        ],
    },
    {
        id: 'fa5c1803a8d94bf3b8dd00e36d724656',
        internalId: 'output',
        enName: 'Output',
        name: 'Output',
        archived: 'false',
        apps: ['ANML', 'PHSP', 'PHSP', 'PSWB', 'PPRO', 'STGR', 'SBSTD'],
    },
    {
        id: '83c6bc05ff1645ed8071f9b33d380560',
        internalId: 'overlay',
        enName: 'Overlay',
        name: 'Overlay',
        archived: 'false',
        apps: ['PEXP'],
    },
    {
        id: '5ef362d439f04456b6df4a4cd8d6c639',
        internalId: 'overview',
        enName: 'Overview',
        name: 'Overview',
        archived: 'false',
        apps: ['AEFT', 'ILST', 'IDSN', 'LPES', 'PHSP', 'FFLY'],
    },
    {
        id: '6b1c2903d7cc42d4854d909438ca52c9',
        internalId: 'pages',
        enName: 'Pages',
        name: 'Pages',
        archived: 'false',
        apps: ['CCEX', 'IDSN'],
    },
    {
        id: '76faf30d1c2e4b28b0f7d91eb04f8e91',
        internalId: 'painting',
        enName: 'Painting',
        name: 'Painting',
        archived: 'false',
        apps: ['AEFT', 'FRSC', 'ILST', 'ILST', 'PHSP', 'PHSP', 'PSWB', 'SBSTP'],
    },
    {
        id: '0c7ab8a8a74d4d7e809aed59f2dc587c',
        internalId: 'panorama',
        enName: 'Panorama',
        name: 'Panorama',
        archived: 'false',
        apps: ['LTRM', 'PHSP', 'PSWB'],
    },
    {
        id: '82384941603a42b79d7fd1bb03641b9a',
        internalId: 'parent-pages',
        enName: 'Parent pages',
        name: 'Parent pages',
        archived: 'false',
        apps: ['IDSN'],
    },
    {
        id: '3671bf91bff14b0995caafb594c0cae4',
        internalId: 'paths',
        enName: 'Paths',
        name: 'Paths',
        archived: 'false',
        apps: ['AEFT', 'PHSP'],
    },
    {
        id: 'c3983b6cdb444170a67ab07ea9f22830',
        internalId: 'patterns',
        enName: 'Patterns',
        name: 'Patterns',
        archived: 'false',
        apps: ['FLPR', 'ILST', 'ILST', 'PHSP', 'SBSTD'],
    },
    {
        id: '7f0ef7ec411d4ee4a3bd94398985f746',
        internalId: 'pbr',
        enName: 'PBR',
        name: 'PBR',
        archived: 'false',
        apps: ['SBSTD'],
    },
    {
        id: '76124a075f734fb78dc94792174359d4',
        internalId: 'pdf',
        enName: 'PDF',
        name: 'PDF',
        archived: 'false',
        apps: ['ACRS', 'IDSN'],
    },
    {
        id: 'd2fe004c0d6548cd90bc37f8cc5a71df',
        internalId: 'perspective',
        enName: 'Perspective',
        name: 'Perspective',
        archived: 'false',
        apps: ['ILST', 'LTRM', 'LPES_MBL', 'PHSP', 'PEXP', 'PSWB'],
    },
    {
        id: '9b64252ba2b14a8da53a96a40021ee7f',
        internalId: 'pet-photography',
        enName: 'Pet photography',
        name: 'Pet photography',
        archived: 'false',
        apps: ['PSWB'],
    },
    {
        id: '5570cf02a98c48b785e3988baad592ad',
        internalId: 'photo-editing',
        enName: 'Photo editing',
        name: 'Photo editing',
        archived: 'false',
        apps: ['CCEX', 'ILST', 'LPES', 'LTRM', 'LPES_MBL', 'PHSP', 'PEXP', 'PHSP', 'PSWB'],
    },
    {
        id: 'd1f4d2f9bbec415691b78696208a9f72',
        internalId: 'photo-restoration',
        enName: 'Photo restoration',
        name: 'Photo restoration',
        archived: 'false',
        apps: ['PHSP', 'PHSP', 'PSWB'],
    },
    {
        id: '30455ab0b3f74e63a1e0618c6390bafd',
        internalId: 'retouching',
        enName: 'Photo retouching',
        name: 'Photo retouching',
        archived: 'false',
        apps: ['LPES', 'LTRM', 'LPES_MBL', 'PHSP', 'PEXP', 'PHSP', 'PSWB'],
    },
    {
        id: 'abbd206e861e4bb5be80da5b28d5fd5b',
        internalId: 'photogrammetry',
        enName: 'Photogrammetry',
        name: 'Photogrammetry',
        archived: 'false',
        apps: ['SBSTA'],
    },
    {
        id: 'dd6b056b46ea45458f8f054ef19657ea',
        internalId: 'placing-photos-inside-text',
        enName: 'Placing photos inside text',
        name: 'Placing photos inside text',
        archived: 'false',
        apps: ['PHSP', 'PHSP', 'PSWB'],
    },
    {
        id: '56a724bbae714df898e8f9c7d383db9a',
        internalId: 'placing-text-behind-objects',
        enName: 'Placing text behind objects',
        name: 'Placing text behind objects',
        archived: 'false',
        apps: ['PHSP', 'PHSP', 'PSWB'],
    },
    {
        id: '77e619cc52b24fa8b2ca2ce3517b387f',
        internalId: 'plan-management',
        enName: 'Plan management',
        name: 'Plan management',
        archived: 'false',
        apps: ['CCEX', 'FRSC', 'RUSH'],
    },
    {
        id: 'eb614883ed1c416d99b43d3e92b4bd36',
        internalId: 'platforms',
        enName: 'Platforms',
        name: 'Platforms',
        archived: 'false',
        apps: ['FLPR'],
    },
    {
        id: 'fd5658c21b3b465183c58f96409363ae',
        internalId: 'polygon',
        enName: 'Polygon',
        name: 'Polygon',
        archived: 'false',
        apps: ['SBSTP'],
    },
    {
        id: '65a0209a0edb48ea88ec45a7f0cecbe6',
        internalId: 'portfolio',
        enName: 'Portfolio',
        name: 'Portfolio',
        archived: 'false',
        apps: ['PHSP'],
    },
    {
        id: 'cee261d9082c4b65967649a52ad7b150',
        internalId: 'portrait-photography',
        enName: 'Portrait photography',
        name: 'Portrait photography',
        archived: 'false',
        apps: ['PSWB'],
    },
    {
        id: '8c43830093c241c69a47af85af75f584',
        internalId: 'post-production',
        enName: 'Post-production',
        name: 'Post-production',
        archived: 'false',
        apps: ['AEFT', 'PPRO', 'RUSH'],
    },
    {
        id: 'eb00af9d11fd48018523eb719beebe40',
        internalId: 'preferences',
        enName: 'Preferences',
        name: 'Preferences',
        archived: 'false',
        apps: ['ILST', 'ILST', 'PHSP', 'PHSP', 'PSWB'],
    },
    {
        id: 'acb37fef39764cdf81431d6256152c39',
        internalId: 'preflight',
        enName: 'Preflight',
        name: 'Preflight',
        archived: 'false',
        apps: ['ACRS'],
    },
    {
        id: '558704ca937b412c9fda8b490453b71b',
        internalId: 'preparing-source-files',
        enName: 'Preparing source files',
        name: 'Preparing source files',
        archived: 'false',
        apps: ['ILST', 'IDSN', 'PHSP'],
    },
    {
        id: 'd837562f843b4424a62cfaa8a9d0ece3',
        internalId: 'presentations',
        enName: 'Presentations',
        name: 'Presentations',
        archived: 'false',
        apps: ['STOK'],
    },
    {
        id: 'f36008204ea14436975cdd383f96e2a7',
        internalId: 'presets',
        enName: 'Presets',
        name: 'Presets',
        archived: 'false',
        apps: ['AEFT', 'FLPR', 'LTRM', 'LPES_MBL', 'PPRO'],
    },
    {
        id: 'c86da4a3f34b49faa21f5d6100d4cd4e',
        internalId: 'preview',
        enName: 'Preview',
        name: 'Preview',
        archived: 'false',
        apps: ['AERO', 'AEFT', 'ANML', 'SBSTD', 'SBSTA'],
    },
    {
        id: 'f4801fb086174a0ab45d6bb2539a3c6d',
        internalId: 'print-design',
        enName: 'Print design',
        name: 'Print design',
        archived: 'false',
        apps: ['ILST', 'ILST', 'IDSN'],
    },
    {
        id: '79fcb6fe28674c088db7254800f44f76',
        internalId: 'printing',
        enName: 'Printing',
        name: 'Printing',
        archived: 'false',
        apps: ['ACRS', 'ILST', 'IDSN', 'LTRM', 'PHSP'],
    },
    {
        id: '5a2a9ede99ca4560aff700ed3d150586',
        internalId: 'product-design',
        enName: 'Product design',
        name: 'Product design',
        archived: 'false',
        apps: ['STGR'],
    },
    {
        id: 'eca6391be8684287bdd91bcc171c5224',
        internalId: 'productivity',
        enName: 'Productivity',
        name: 'Productivity',
        archived: 'false',
        apps: ['AEFT', 'ILST', 'IDSN', 'LTRM', 'PHSP'],
    },
    {
        id: '977b82bed9484ee2929a8f485a178f42',
        internalId: 'profiles',
        enName: 'Profiles',
        name: 'Profiles',
        archived: 'false',
        apps: ['LPES_MBL'],
    },
    {
        id: 'e43cd08698db42cf8d11a5af94197f55',
        internalId: 'projection',
        enName: 'Projection',
        name: 'Projection',
        archived: 'false',
        apps: ['SBSTP'],
    },
    {
        id: 'b541fbb13af84d818a11f3d4bdb478ff',
        internalId: 'projects',
        enName: 'Projects',
        name: 'Projects',
        archived: 'false',
        apps: ['CCEX', 'ANML', 'PPRO', 'RUSH', 'SBSTP'],
    },
    {
        id: '42900637c10042feb62fdc7df08dfc1b',
        internalId: 'promotional-video',
        enName: 'Promotional video',
        name: 'Promotional video',
        archived: 'false',
        apps: ['PPRO'],
    },
    {
        id: 'b1031eb8e70a4b158cd35383bca84d9b',
        internalId: 'prototype',
        enName: 'Prototype',
        name: 'Prototype',
        archived: 'false',
        apps: [],
    },
    {
        id: 'c256ce49525b44e09af98a30dd218bb7',
        internalId: 'publish',
        enName: 'Publish',
        name: 'Publish',
        archived: 'false',
        apps: ['CCEX', 'AERO', 'FLPR', 'FRSC', 'IDSN', 'LTRM', 'SBSTD'],
    },
    {
        id: '1c075ad859ad4a4da98403e3d4f396bc',
        internalId: 'puppet',
        enName: 'Puppet',
        name: 'Puppet',
        archived: 'false',
        apps: ['AEFT', 'ANML'],
    },
    {
        id: '137a66331f144834b43e3f719c088323',
        internalId: 'quick-actions',
        enName: 'Quick actions',
        name: 'Quick actions',
        archived: 'false',
        apps: ['CCEX', 'PSWB'],
    },
    {
        id: 'e2c78e3186884c6183915fc464f5f514',
        internalId: 'raw',
        enName: 'Raw',
        name: 'Raw',
        archived: 'false',
        apps: ['PHSP'],
    },
    {
        id: '30bc9fa1b0d94f78acd8c0fc98e64df5',
        internalId: 'recording',
        enName: 'Recording',
        name: 'Recording',
        archived: 'false',
        apps: ['AEFT'],
    },
    {
        id: '24501361c74c49eb876fb43ab5b40f10',
        internalId: 'reflect',
        enName: 'Reflect',
        name: 'Reflect',
        archived: 'false',
        apps: ['ILST', 'ILST', 'PHSP', 'PSWB'],
    },
    {
        id: '930b1fd1aa2e4ec0bde54a2e76fd658b',
        internalId: 'reflections',
        enName: 'Reflections',
        name: 'Reflections',
        archived: 'false',
        apps: ['SBSTD'],
    },
    {
        id: 'a79c578f6fa24f3183d629807c686e57',
        internalId: 'removing-backgrounds',
        enName: 'Removing backgrounds',
        name: 'Removing backgrounds',
        archived: 'false',
        apps: ['PHSP', 'PHSP', 'PSWB', 'FFLY'],
    },
    {
        id: '21e89dab690b4560a31b9f0af7022f26',
        internalId: 'removing-objects',
        enName: 'Removing objects',
        name: 'Removing objects',
        archived: 'false',
        apps: ['AEFT', 'LPES', 'LTRM', 'LPES_MBL', 'PHSP', 'PEXP', 'PHSP', 'PSWB', 'FFLY'],
    },
    {
        id: 'ddb3513acdf94f6fab4ded9233234a55',
        internalId: 'rendering',
        enName: 'Rendering',
        name: 'Rendering',
        archived: 'false',
        apps: ['AEFT', 'PHSP', 'SBSTP'],
    },
    {
        id: '64a1f10a60814b1793bf805b2e419a89',
        internalId: 'replacing-backgrounds',
        enName: 'Replacing backgrounds',
        name: 'Replacing backgrounds',
        archived: 'false',
        apps: ['PHSP', 'PHSP', 'PSWB', 'FFLY'],
    },
    {
        id: '13464284a4fa478391d1e1a99a481cd3',
        internalId: 'resize',
        enName: 'Resize',
        name: 'Resize',
        archived: 'false',
        apps: ['ILST', 'ILST', 'LPES', 'PHSP', 'PEXP', 'PHSP', 'PSWB', 'PPRO'],
    },
    {
        id: 'd9d1c777afde47a8acfbe34823899eea',
        internalId: 'resolution',
        enName: 'Resolution',
        name: 'Resolution',
        archived: 'false',
        apps: ['SBSTD'],
    },
    {
        id: '3832c16397964df1a06866e68256f2d1',
        internalId: 'responsive-design',
        enName: 'Responsive design',
        name: 'Responsive design',
        archived: 'false',
        apps: ['FLPR', 'ILST', 'PHSP'],
    },
    {
        id: '099f0254c9ab4d199b7d6282f385a94f',
        internalId: 'review-comment',
        enName: 'Review and comment',
        name: 'Review and comment',
        archived: 'false',
        apps: ['ACRS', 'LTRM', 'PSWB'],
    },
    {
        id: 'f35847fb1c0e4b8c8ea94040a83bde7c',
        internalId: 'rigging',
        enName: 'Rigging',
        name: 'Rigging',
        archived: 'false',
        apps: ['ANML'],
    },
    {
        id: 'f13b69b401f046b4b2f659da09eadb62',
        internalId: 'rotate',
        enName: 'Rotate',
        name: 'Rotate',
        archived: 'false',
        apps: ['ILST', 'ILST', 'PHSP', 'PHSP', 'PSWB'],
    },
    {
        id: 'a683cfcbff3146ab88f599f9579e5a6f',
        internalId: 'rotoscoping',
        enName: 'Rotoscoping',
        name: 'Rotoscoping',
        archived: 'false',
        apps: ['AEFT'],
    },
    {
        id: '5e5d30915ef2411b9fe528aec78dc589',
        internalId: 'save',
        enName: 'Save',
        name: 'Save',
        archived: 'false',
        apps: ['ACRS', 'ILST', 'ILST', 'LTRM', 'LPES_MBL', 'PHSP', 'PEXP', 'PHSP', 'PSWB', 'RUSH', 'STOK'],
    },
    {
        id: '6c603badd6bb46edbb48c039d0526309',
        internalId: 'scaling',
        enName: 'Scaling',
        name: 'Scaling',
        archived: 'false',
        apps: ['ILST', 'ILST', 'PHSP', 'PSWB'],
    },
    {
        id: '14853c748d554e3d9e47233a54ff2324',
        internalId: 'scenes',
        enName: 'Scenes',
        name: 'Scenes',
        archived: 'false',
        apps: ['ANML', 'FLPR'],
    },
    {
        id: 'e5f25f417cea4066955bece0dc4b88dc',
        internalId: 'security',
        enName: 'Security',
        name: 'Security',
        archived: 'false',
        apps: ['ACRS', 'PEXP'],
    },
    {
        id: 'f22fa5991a7345c0a639f887f6ae6cac',
        internalId: 'selections',
        enName: 'Selections',
        name: 'Selections',
        archived: 'false',
        apps: ['AERO', 'ILST', 'ILST', 'LPES_MBL', 'PHSP', 'PEXP', 'PHSP', 'PSWB', 'SHPR'],
    },
    {
        id: 'f65236cb62894032a43e9da9a8ebf4a8',
        internalId: 'sequences',
        enName: 'Sequences',
        name: 'Sequences',
        archived: 'false',
        apps: ['PPRO', 'RUSH'],
    },
    {
        id: '0fbb1b573a2b4704a4090aa4ef690133',
        internalId: 'shading',
        enName: 'Shading',
        name: 'Shading',
        archived: 'false',
        apps: ['SBSTP'],
    },
    {
        id: '0194027c643146e383a5b5c814a69c60',
        internalId: 'shapes',
        enName: 'Shapes',
        name: 'Shapes',
        archived: 'false',
        apps: ['CCEX', 'AEFT', 'FLPR', 'FRSC', 'ILST', 'ILST', 'PHSP', 'SBSTD'],
    },
    {
        id: '3d28300b308641648fa7a3f2008ab421',
        internalId: 'share',
        enName: 'Share',
        name: 'Share',
        archived: 'false',
        apps: [
            'CCEX',
            'AERO',
            'FLPR',
            'FRSC',
            'ILST',
            'ILST',
            'IDSN',
            'LPES',
            'LPES_MBL',
            'PHSP',
            'PEXP',
            'PHSP',
            'PSWB',
            'RUSH',
        ],
    },
    {
        id: '47f74360791247bd8d7a80c16d52972a',
        internalId: 'sharpen',
        enName: 'Sharpen',
        name: 'Sharpen',
        archived: 'false',
        apps: ['LTRM', 'LPES_MBL', 'PHSP', 'PEXP'],
    },
    {
        id: '97e1a95a2f43418bb8da6f8abd7174ec',
        internalId: 'shortcuts',
        enName: 'Shortcuts',
        name: 'Shortcuts',
        archived: 'false',
        apps: [
            'CCEX',
            'AEFT',
            'FLPR',
            'ANML',
            'FRSC',
            'ILST',
            'ILST',
            'IDSN',
            'LPES',
            'LTRM',
            'PHSP',
            'PHSP',
            'PSWB',
            'PPRO',
            'RUSH',
        ],
    },
    {
        id: '77d2de3743ec4262b7c7eeaf344eb700',
        internalId: 'signatures',
        enName: 'Signatures',
        name: 'Signatures',
        archived: 'false',
        apps: ['ACRS'],
    },
    {
        id: '541589677b6f40b3b958365f183cfcc3',
        internalId: 'slideshow',
        enName: 'Slideshow',
        name: 'Slideshow',
        archived: 'false',
        apps: ['LTRM', 'PHSP'],
    },
    {
        id: 'e9700531f52c48969ffa36037f363bfe',
        internalId: 'smart-object',
        enName: 'Smart object',
        name: 'Smart object',
        archived: 'false',
        apps: ['PHSP', 'PHSP', 'PSWB'],
    },
    {
        id: '702252317a7444b58b7f0074b8f15334',
        internalId: 'snapshots',
        enName: 'Snapshots',
        name: 'Snapshots',
        archived: 'false',
        apps: ['ANML'],
    },
    {
        id: '058148b95a584a6faacb6d8877b2f85f',
        internalId: 'social-media',
        enName: 'Social media graphics',
        name: 'Social media graphics',
        archived: 'false',
        apps: ['CCEX', 'ILST', 'ILST', 'PHSP', 'PHSP', 'PSWB', 'PPRO', 'STOK'],
    },
    {
        id: '1988691a95e8406b9bbfe8954289a39f',
        internalId: 'social-media-scheduler',
        enName: 'Social media scheduler',
        name: 'Social media scheduler',
        archived: 'false',
        apps: ['CCEX'],
    },
    {
        id: 'd1994573d7c6491dbcd936bdafe89167',
        internalId: 'social-media-videos',
        enName: 'Social media videos',
        name: 'Social media videos',
        archived: 'false',
        apps: ['PPRO', 'RUSH', 'STOK'],
    },
    {
        id: '571603f210c847afb281d26c656b7b7c',
        internalId: 'speed',
        enName: 'Speed',
        name: 'Speed',
        archived: 'false',
        apps: ['RUSH'],
    },
    {
        id: 'a3af425ff1404563a77a6eac6960a2b6',
        internalId: 'stage',
        enName: 'Stage',
        name: 'Stage',
        archived: 'false',
        apps: ['FLPR'],
    },
    {
        id: '982fc9643db340319cbb6fb5ee52ceb5',
        internalId: 'staging',
        enName: 'Staging',
        name: 'Staging',
        archived: 'false',
        apps: ['FLPR'],
    },
    {
        id: '2ac7f44e3f2147e684d2e00c9691cc30',
        internalId: 'stickers',
        enName: 'Stickers',
        name: 'Stickers',
        archived: 'false',
        apps: ['PEXP'],
    },
    {
        id: '971fbd28f7fe436190f44657588b312f',
        internalId: 'adobe-stock-contributor',
        enName: 'Stock Contributor',
        name: 'Stock Contributor',
        archived: 'false',
        apps: ['STOK'],
    },
    {
        id: 'df1b3fe456ef493aa2ed684337baa05b',
        internalId: 'streaming',
        enName: 'Streaming',
        name: 'Streaming',
        archived: 'false',
        apps: ['ANML'],
    },
    {
        id: '169422eff08e47d48c1f014845dfb8c3',
        internalId: 'street-photography',
        enName: 'Street photography',
        name: 'Street photography',
        archived: 'false',
        apps: ['PSWB'],
    },
    {
        id: 'ae43e336b22f4566996a4dfef1ea320e',
        internalId: 'strokes',
        enName: 'Strokes',
        name: 'Strokes',
        archived: 'false',
        apps: ['ILST', 'ILST'],
    },
    {
        id: '5c903a1ebb104863973ae26e419b41d8',
        internalId: 'styles',
        enName: 'Styles',
        name: 'Styles',
        archived: 'false',
        apps: ['ILST', 'IDSN', 'PHSP', 'FFLY'],
    },
    {
        id: '60046755cdb54ba690e3fdfae82bf409',
        internalId: 'swatches',
        enName: 'Swatches',
        name: 'Swatches',
        archived: 'false',
        apps: ['ILST', 'ILST', 'IDSN', 'PHSP', 'PHSP'],
    },
    {
        id: 'd857ac0ea7dd4763b27919a53e69e63d',
        internalId: 'symbols',
        enName: 'Symbols',
        name: 'Symbols',
        archived: 'false',
        apps: ['ILST', 'PHSP'],
    },
    {
        id: '45f227ce626f4246a6cc5a97aff6b76f',
        internalId: 'system-requirements',
        enName: 'System requirements',
        name: 'System requirements',
        archived: 'false',
        apps: [
            'AEFT',
            'FRSC',
            'ILST',
            'ILST',
            'IDSN',
            'LPES',
            'LTRM',
            'LPES_MBL',
            'PHSP',
            'PHSP',
            'PSWB',
            'PPRO',
            'RUSH',
            'SBSTP',
        ],
    },
    {
        id: 'b8557104ef0e4ce788a074f24f0c6f63',
        internalId: 'tables',
        enName: 'Tables',
        name: 'Tables',
        archived: 'false',
        apps: ['IDSN'],
    },
    {
        id: 'fa02d178bf7c41ccae9fdcb064c2b5e0',
        internalId: 'take-photos',
        enName: 'Take photos',
        name: 'Take photos',
        archived: 'false',
        apps: ['PEXP'],
    },
    {
        id: '353572104a3946b2ac57aee55fd974a3',
        internalId: 'templates',
        enName: 'Templates',
        name: 'Templates',
        archived: 'false',
        apps: ['CCEX', 'AEFT', 'FLPR', 'ILST', 'ILST', 'IDSN', 'LTRM', 'PHSP', 'PHSP', 'PPRO', 'STOK'],
    },
    {
        id: '74d6b374f69f45b6a227b3ab6199d970',
        internalId: 'text',
        enName: 'Text',
        name: 'Text',
        archived: 'false',
        apps: [
            'CCEX',
            'AEFT',
            'FLPR',
            'FRSC',
            'ILST',
            'ILST',
            'IDSN',
            'PHSP',
            'PEXP',
            'PHSP',
            'PSWB',
            'PPRO',
            'RUSH',
            'FFLY',
        ],
    },
    {
        id: 'c120547a8f4b471a95ef601dff68cb75',
        internalId: 'texture',
        enName: 'Texture',
        name: 'Texture',
        archived: 'false',
        apps: ['ILST', 'LPES_MBL', 'PHSP', 'SBSTD', 'SBSTP'],
    },
    {
        id: '62c04f20e96645f1856dcf72b7be7331',
        internalId: 'themes',
        enName: 'Themes',
        name: 'Themes',
        archived: 'false',
        apps: ['PEXP'],
    },
    {
        id: '9f23b575d1ed4ecf948e4f87323dde45',
        internalId: 'thumbnails',
        enName: 'Thumbnails',
        name: 'Thumbnails',
        archived: 'false',
        apps: ['SBSTD'],
    },
    {
        id: '2e1d56ece10f43598b2c0582042a1f88',
        internalId: 'tiling',
        enName: 'Tiling',
        name: 'Tiling',
        archived: 'false',
        apps: ['SBSTA'],
    },
    {
        id: '477afdf4ab3a47a2b9c7ca6e7a67b66c',
        internalId: 'timeline',
        enName: 'Timeline',
        name: 'Timeline',
        archived: 'false',
        apps: ['AEFT', 'FLPR', 'ANML', 'PHSP', 'PPRO'],
    },
    {
        id: 'a8a905d4d5924821895314129e2da0a1',
        internalId: 'titles',
        enName: 'Titles',
        name: 'Titles',
        archived: 'false',
        apps: ['PPRO', 'RUSH'],
    },
    {
        id: '0805d939377142509c05eb218b9de65e',
        internalId: 'tone',
        enName: 'Tone',
        name: 'Tone',
        archived: 'false',
        apps: ['LTRM', 'PHSP', 'PHSP', 'PSWB'],
    },
    {
        id: '25253e8817e549788d3c4caed094e40c',
        internalId: 'tracking-matte',
        enName: 'Tracking matte',
        name: 'Tracking matte',
        archived: 'false',
        apps: ['PPRO'],
    },
    {
        id: '26540cfed893488ab88b7dff3b270af1',
        internalId: 'transform',
        enName: 'Transform',
        name: 'Transform',
        archived: 'false',
        apps: ['ILST', 'ILST', 'PHSP', 'PHSP', 'PSWB'],
    },
    {
        id: 'df2708343e4941d58372c3047a892093',
        internalId: 'transitions',
        enName: 'Transitions',
        name: 'Transitions',
        archived: 'false',
        apps: ['AEFT', 'PPRO'],
    },
    {
        id: 'a05caf043caa4f3f8ae0779848f83ea5',
        internalId: 'transparency',
        enName: 'Transparency',
        name: 'Transparency',
        archived: 'false',
        apps: ['AEFT', 'ILST', 'ILST', 'IDSN', 'PHSP', 'PHSP', 'PSWB'],
    },
    {
        id: 'efca6db29255409f9897ff87fcff6200',
        internalId: 'travel-photography',
        enName: 'Travel photography',
        name: 'Travel photography',
        archived: 'false',
        apps: ['PSWB'],
    },
    {
        id: 'd79730b0b3a14969b55ea1cac2378b40',
        internalId: 'triggers',
        enName: 'Triggers',
        name: 'Triggers',
        archived: 'false',
        apps: ['AERO', 'ANML'],
    },
    {
        id: '3fc817b8a9dd440d8ad54adca83d61d6',
        internalId: 'troubleshooting',
        enName: 'Troubleshooting',
        name: 'Troubleshooting',
        archived: 'false',
        apps: ['FLPR', 'ANML', 'FRSC', 'ILST', 'ILST', 'IDSN', 'LTRM', 'PHSP', 'PHSP', 'PSWB', 'PPRO', 'STOK'],
    },
    {
        id: '924cacb737dc47eb929b98c1e83de3bd',
        internalId: 'tween',
        enName: 'Tween',
        name: 'Tween',
        archived: 'false',
        apps: ['FLPR'],
    },
    {
        id: '23575a8fb21348028d74f2a15c8aff15',
        internalId: 'typography',
        enName: 'Typography',
        name: 'Typography',
        archived: 'false',
        apps: ['ILST', 'ILST', 'IDSN', 'PHSP', 'PEXP', 'PHSP', 'PSWB', 'STOK'],
    },
    {
        id: 'ee01f00a04d443dda890ff7cacfec299',
        internalId: 'vector',
        enName: 'Vector',
        name: 'Vector',
        archived: 'false',
        apps: ['AEFT', 'ILST', 'ILST', 'PHSP', 'STOK', 'FFLY'],
    },
    {
        id: '789621f8d4084f1d813063df84c55a1b',
        internalId: 'versions',
        enName: 'Versions',
        name: 'Versions',
        archived: 'false',
        apps: ['LPES_MBL', 'PSWB'],
    },
    {
        id: '6db1a66d4dc446ae971e3da8101bc448',
        internalId: 'vibrance',
        enName: 'Vibrance',
        name: 'Vibrance',
        archived: 'false',
        apps: ['LPES_MBL', 'PHSP', 'PHSP', 'PSWB'],
    },
    {
        id: '24fd8e87f017494b85a64d022d2c81e1',
        internalId: 'video',
        enName: 'Video',
        name: 'Video',
        archived: 'false',
        apps: ['CCEX', 'AEFT', 'FLPR', 'PHSP', 'PPRO', 'RUSH', 'STOK'],
    },
    {
        id: '1a4bf81f09114391ae2330bf04b5fd6d',
        internalId: 'video-editing',
        enName: 'Video editing',
        name: 'Video editing',
        archived: 'false',
        apps: ['LPES', 'LPES_MBL', 'PHSP', 'PPRO'],
    },
    {
        id: '2a958bc4598f4b66b548e353cbe7c7c7',
        internalId: 'views',
        enName: 'Views',
        name: 'Views',
        archived: 'false',
        apps: ['AEFT', 'SBSTP'],
    },
    {
        id: '362a11dafc6a4b0f98d19bfe49d97fdb',
        internalId: 'vignette',
        enName: 'Vignette',
        name: 'Vignette',
        archived: 'false',
        apps: ['LPES_MBL', 'PHSP', 'PSWB'],
    },
    {
        id: 'aaa680a7f7be4972a112dc155d929aab',
        internalId: 'virtual-photography',
        enName: 'Virtual photography',
        name: 'Virtual photography',
        archived: 'false',
        apps: ['STGR'],
    },
    {
        id: '17b3b30a585043b68cc70f85aac4a524',
        internalId: 'visual-effects',
        enName: 'Visual effects',
        name: 'Visual effects',
        archived: 'false',
        apps: ['PPRO'],
    },
    {
        id: '250aae5d9af54ce1819ccbc005549b87',
        internalId: 'voiceover',
        enName: 'Voiceover',
        name: 'Voiceover',
        archived: 'false',
        apps: ['RUSH'],
    },
    {
        id: '782b738cc9784e7ba37568fcb4cf6f45',
        internalId: 'volume',
        enName: 'Volume',
        name: 'Volume',
        archived: 'false',
        apps: ['AEFT', 'PPRO', 'RUSH'],
    },
    {
        id: '3661609549cc4e8fa88d01741db765e0',
        internalId: 'vr-and-360',
        enName: 'VR and 360',
        name: 'VR and 360',
        archived: 'false',
        apps: ['AEFT', 'PPRO', 'SHPR'],
    },
    {
        id: 'e0704c35fc3447c8a4a1992fe61d8e90',
        internalId: 'web-design',
        enName: 'Web design',
        name: 'Web design',
        archived: 'false',
        apps: ['ILST', 'PHSP', 'PSWB'],
    },
    {
        id: '24c747d104aa44f491b963e31a14e5b2',
        internalId: 'whats-new',
        enName: "What's new",
        name: "What's new",
        archived: 'false',
        apps: ['PHSP'],
    },
    {
        id: '85e8e39b2df64f01939be8d76dec93a9',
        internalId: 'workflow',
        enName: 'Workflow',
        name: 'Workflow',
        archived: 'false',
        apps: ['AERO', 'FLPR', 'ILST', 'ILST', 'IDSN', 'PHSP', 'PSWB', 'PPRO'],
    },
    {
        id: '0663589c5ca34a31b12740eb14cc606c',
        internalId: 'workspace',
        enName: 'Workspace',
        name: 'Workspace',
        archived: 'false',
        apps: ['ACRS', 'AERO', 'AEFT', 'FLPR', 'ANML', 'FRSC', 'ILST', 'ILST', 'IDSN', 'LTRM', 'PHSP', 'PSWB', 'PPRO'],
    },
    {
        id: '3025094cef834f64b27add31b106e1a7',
        internalId: 'xr',
        enName: 'XR',
        name: 'XR',
        archived: 'false',
        apps: ['STGR'],
    },
];
